
import React, { useState, useEffect, useContext } from "react";


import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from 'axios';
import tmdbApi from "../api/tmdbApi";
import moment from "moment";

import SweetAlert from 'react-bootstrap-sweetalert';
import * as Config from "../constants/Config";
import Loader from "../components/loader";
import { contentContext } from "../context/contentContext";
import SessionPopup from "../pages/SessionPopup"
import TableLoader from "../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import LocationSearch from "./LocationSearch";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
let { lambda, appname } = window.app

const BusinessProfile = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");
    const [countries, setCountries] = useState('');
    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);
    const [toastType, setToastType] = useState("");// State for dynamic message
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
   // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);
    const [files, setFiles] = useState([]);
   
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [selectedPlace, setSelectedPlace] = useState('');
    const [addressData, setAddressData] = useState({});
    const [filesData, setFilesData] = useState([]);
    const [disableSaveBtn, setDisableSaveBtn] = useState(false);
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum]= useState();
    const [btnLoader, setBtnLoader]= useState(false);
    const [error, setError] = useState('');
    
 const [image, setImg] = useState('');
    // const [sortDirection, setSortDirection] = useState('asc');
         
    // let siteConfig = window?.site?.common;
    // let appResourcesUrl = siteConfig?.imageCloudfront;

    let id = localStorage.getItem("userId");

    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const {clientInfo, setClientInfo,searchedFlag,businessData,setBusinessData, setSearchedFlag,  isLoading,mapsAPIkey, setIsLoading,userData, setUserData,GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch ,currentPage, setcurrentPage, data, setData,rowsPerPage, setRowsPerPage,currentPageNew, setCurrentPage,route, setRoute,usePrevious, setActiveMenuId,  GetTimeActivity} = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu==="User Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
     useEffect(() => {
         if(prevRoute !== undefined && prevRoute!=route){
             setCurrentPage(1)
             setRowsPerPage(15)
             setSearchedFlag(false);
             setUserSearch("")
         }
     }, [prevRoute]);

     useEffect(() => {
        // getclient()
    }, []);
  
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    
    
    }, [window.site]);
     
  
    useEffect(() => {
        setRoute("user")
       //  GetClientDataContext()
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management":false,
            "Reports": false
        })
       //  // userActivity();
    }, []);

    useEffect(() => {
        if (toastMessage && toastType && toast[toastType]) {
            toast[toastType](toastMessage, {
                position: "bottom-center",
                // autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            // Clear the message after showing to prevent re-triggering
            setToastMessage && setToastMessage("");
        }
    }, [toastMessage, toastType]);
      

  

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        GetCountries()
    }, []);

  
    const handleCountryChange = (e) => {
        const newCountry = e.target.value;
        // setIdc(newCountry); // Update state
        
        setBusinessData((prev) => ({
            ...prev,
            idc: newCountry,
            phone: "", // Reset phone number when country changes
        }));
    
    };
   
    const handleChange = (event) => {
        const { name, value } = event.target;

        // Check if the field being updated is the phone number
        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = businessData?.idc?.trim(); // Directly get the latest idc value

    if (currentIdc === "USA") {
        console.log("Using USA Format");
        if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
        if (numericValue.length > 6) {
            formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
        } else if (numericValue.length > 3) {
            formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
        } else {
            formattedValue = numericValue;
        }
    } else if (currentIdc === "IND") {
        console.log("Using India Format");
        if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
        if (numericValue.length > 5) {
            formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
        } else {
            formattedValue = numericValue;
        }
    }
    setError({ ...error, phone: "" })
    // Update the phone number only
    setBusinessData(prev => ({ ...prev, [name]: formattedValue }));

          } else if (name === "businessname") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setBusinessData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...error, businessname: "" })

        }else if (name === "emailId") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setBusinessData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...error, emailId: "" })

        }  else {
            // Allow normal updates for other fields
            setBusinessData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the changed field
            }));
        }
    };



    const handleAddressChange = (addressData) => {
        setBusinessData(prevState => ({
            ...prevState,
            businessaddress: addressData.fullAddress || ''
        }));
        setError((prevError) => ({
        ...prevError,
        businessaddress: "",
    }));
    };
    const GetCountries = async () => {
        try {

            const response = await tmdbApi.getLookUp({
                "type": ["country"],
                "sortBy": "alpha3",
                // "projection": "tiny"
            });

            const countries = response?.result?.data || [];
            setCountries(countries);
            const usaCountry = countries.filter(
                eachItem => eachItem.countrycode.trim() === "(+1)" && eachItem.alpha2.trim() === "US"
            );

        // Print the filtered country in the console
        console.log("USA Country:", usaCountry);
        setBusinessData({...businessData,idc:usaCountry?.[0]?.alpha3})
           

        } catch {
            console.log("error");
        }
    };
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        // const selectedFilesSize = selectedFile.size; //for single file
        const selectedFiles = Array.from(event.target.files);  //for multiple files
        
        const allowedFileTypes = ["image/jpeg", "image/png", "image/heic"];
        let fileSize = 1048612 * 5 // 5MB
        if (selectedFile && !allowedFileTypes.includes(selectedFile.type)) {
            setToastMessage("Only JPG, PNG, and HEIC files are allowed!");
            setToastMessage("warning")
            event.target.value = null;
            return;
        }else 
    
        if (selectedFile.size < fileSize) {
                const previewUrl = URL.createObjectURL(selectedFile);
                setBusinessData(prev => ({
                    ...prev,
                    logo: [{ filepath: previewUrl }]
                }));
                setFilesData([selectedFile]); // Store file data
               
            } else {
                setToastMessage("File size should not exceed 5MB"); // Set the error message
                setToastMessage("warning")
                event.target.value = null;
        
            }
         
        
    
    
        // setFiles([...files, ...selectedFiles]); //for multiple files
    
    
    
    
    };
   
 
    
    
    const handleUploadSubmit = async () => {
setBtnLoader(true)
        const ObjectID = require("bson-objectid");
        const uniqueId = new ObjectID().toString();
        // setLocationId(locationId)






        if (filesData && filesData?.length > 0) {
            setDisableSaveBtn(true)
            const uploadPromises = Array.from(filesData).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const clientid = localStorage.getItem('userId');
                const token = localStorage.getItem('token');
                const ObjectID = require("bson-objectid");

                const uniqueId = new ObjectID().toString();
                let uploadFilePath;
                let bucket;

                // Check the file type
                if (file.type.startsWith('image/')) {
                    // File is an image
                    let filenameReplace = file.name.replace(/ /g, "_")
                    uploadFilePath = `${appname}/${uniqueId}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    bucket = window?.site?.common?.resourceBucket; // Use resource bucket for images
                    const data = {
                        source_bucket: bucket, // Use the correct bucket based on file type
                        sourcepath: uploadFilePath
                    };
                    console.log("data", data)
                    const newFile = [{
                        filename: filenameReplace.split('.')[0],
                        filepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    }]
                    const updatedFiles = [...files, ...newFile];
                    console.log("updatedFiles", updatedFiles)
                    setFiles(updatedFiles);

                    const uploadPromise = axios.post(
                        `${lambda}/uploadURL?appname=${appname}`,
                        data,
                        { headers: { 'Content-Type': 'application/json' } }
                    ).then(async uploadUrlResponse => {
                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const url = uploadUrlResponse.data.result;

                            return axios.put(url, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            }).then(async uploadResponse => {
                                if (uploadResponse.status === 200) {
                                    // setFiles([...files, ...newFile]); 
                                    // handleSubmit(updatedFiles);
                                   
                                        handleUpdate(updatedFiles);
                                    

                                } else {
                                    throw new Error('Failed to upload file to S3');
                                }
                            });
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    });


                }


            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);

            } catch (error) {
                console.error('Error during file upload:', error);
            }
        } else {
            // handleSubmit([], uniqueId);
            
               
          

                handleUpdate([], uniqueId);
            


        }



    }
    const getclient = async (e) => {
        GetTimeActivity(); // Ensure this function is defined elsewhere
    
        const token = localStorage.getItem("token");
    
      
        try {
            const response = await tmdbApi.getClientInfo();
    
            if (response?.result?.length > 0) {
                setBusinessData(response.result[0]);
                setClientInfo(response.result[0])
            } 
        } catch (error) {
            console.error("Error fetching client info:", error);
        }
    };
    const handleUpdate = (filesData) => {
        GetTimeActivity()
        setDisableSaveBtn(true)


        let logoImage =  filesData?.[0]?.filepath;



        let payload = {
            "businessname": businessData?.businessname?.trim() || "",
            "idc": businessData?.idc,
            "phone": businessData?.phone?.trim() ?? "",
            "emailId": businessData?.emailId?.trim() ?? "",
            // "subscription": businessData?.subscription?.trim() ?? "",
            "businessaddress": businessData?.businessaddress?.trim() ?? "",
            "logo": filesData?.length > 0 ? logoImage : businessData?.logo,
            
          
        };
      
        const token = localStorage.getItem("token")
        const userid = localStorage.getItem("userId")

        axios.post(lambda + '/updateClient?appname=' + appname  + '&clientid=' + clientInfo?.clientid +'&token='+token, payload,)
            // "&token=" + token 
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    if (response?.data?.result === "Invalid token or Expired") {
                        setShowSessionPopupup(true)
                    } else {
                        setBtnLoader(false)
                        getclient()
                       
                        setIsLoading(false);
                        setToastMessage("Client Details Updated Successfully")
                        setToastType("success")
                      
                    }
                }
            }).catch((err) => {
                setIsLoading(false);
                console.log('errr', err)
            });

        // }
    }
    const handleValidations = () => {
        let formIsValid = true;
        if (businessData?.businessname === "") {
            setError((prevData) => ({
                ...prevData,
                ["businessname"]: "Please enter Name",
            }));


            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["businessname"]: "",
            }));
        }
        if (businessData?.businessaddress === "") {
            setError((prevData) => ({
                ...prevData,
                ["businessaddress"]: "Please enter businessaddress",
            }));


            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["businessaddress"]: "",
            }));
        }
        if (businessData?.phone === "") {
            setError((prevData) => ({
                ...prevData,
                ["phone"]: "Please enter phone number",
            }));


            formIsValid = false;
        }else if (
            (businessData.idc?.trim() === "USA" && !/^\(\d{3}\) \d{3}-\d{4}$/.test(businessData.phone)) ||
            (businessData.idc.trim() === "IND" && !/^\d{5}-\d{5}$/.test(businessData.phone))
        ) {
            setError((prevData) => ({
                ...prevData,
                ["phone"]: 'Invalid phone number format',
            }));
            
            formIsValid = false;
        }


        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (businessData?.emailId === "") {
            setError((prevData) => ({
                ...prevData,
                ["emailId"]: "Please enter Email",
            }));

            formIsValid = false;
        } else if (!emailRegex.test(businessData?.emailId)) {
            setError((prevData) => ({
                ...prevData,
                ["emailid"]: "Please enter a valid Email address",
            }));


            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["email"]: "",
            }));
        }

        return formIsValid;
    }
const handleSave=()=>{
    const validate=handleValidations()
    if(validate){
        handleUploadSubmit()
    }
  
}
  
    const handleRemove = () => {
        // setUploadImg("")
        //setFormData("")
        setFilesData([])
        setBusinessData(prev => ({
            ...prev,
            logo: ""// Clear the logo array
        }));
    }

    return (
        <>
            {showSessionPopupup && <SessionPopup />}
            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                {/* Start right Content here  */}
              
                    <div className="main-content user-management">

                        <div className="page-content">
                            <div className="container-fluid">



                                <div className="row  breadcrumb">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">

                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title">BUSINESS PROFILE</h4>

                                            </div>
                                            {/* {subValDashboard && subValDashboard.Add && subValDashboard.Add.display === true &&
                                                <div>
                                                    <button className="fill-btn-style" onClick={handleAddUser} disabled={subValDashboard && subValDashboard.Add && subValDashboard.Add.enable === false}>ADD USER</button>
                                                </div>} */}
                                        </div>
                                    </div>
                                </div>

                                <div className="row table-data">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body Bussiness-Profile">
                                            {/* Business Profile Start here */}
<div className="row">
<div className="col-md-6">
{/* <h4 class="form-title mb-0">Dario Bar and lounge</h4> */}
<label className="form_label mt-3" for="location-name">BUSINESS NAME <span className="required">*</span></label>
                        <div className="input-group mb-2 mr-sm-2">
                        <div className="input-group-prepend">
                        <div className="input-group-text">
                        <span className="material-symbols-outlined">storefront</span>
                        </div>
                        </div>
                        <input className="form-control" name="businessname" value={businessData?.businessname} placeholder="Enter Location Name" type="text"   onChange={handleChange}/>
                        {error && <span className="errormsg" style={{
                                        fontWeight: 'bold',
                                        color: 'red',
                                    }}>{error?.businessname}</span>}
                        </div>
<label className="form_label mt-3" for="location-name">BUSINESS EMAIL<span className="required">*</span></label>
                        <div className="input-group mb-2 mr-sm-2">
                        <div className="input-group-prepend">
                        <div className="input-group-text">
                        <span className="material-symbols-outlined">mail</span>
                        </div>
                        </div>
                        <input className="form-control" name="emailId" value={businessData?.emailId}placeholder="Enter Location Name" type="text" onChange={handleChange}/>
                        {error && <span className="errormsg" style={{
                                        fontWeight: 'bold',
                                        color: 'red',
                                    }}>{error?.emailId}</span>}
                        </div>
<label className="form_label mt-3" for="location-name">BUSINESS PHONE NUMBER <span className="required">*</span></label>
                        <div className="input-group mb-2 mr-sm-2">
                        <div className="input-group-prepend">
                        <div className="input-group-text">
                        <span className="material-symbols-outlined">call</span>
                        </div>
                        </div>
                        <select name="idc" className="colorselect capitalize" 
                                  onChange={handleCountryChange} value={businessData?.idc}>
                                        {countries && countries?.length > 0 && countries?.map((task, i) => {
                                                                                return (
                                                                                    <><option key={i} value={task.alpha3}>{task.alpha3}{task.countrycode}</option></>
                                                                                )
                                                                            }
                                                                            )}
                                    </select>
                        <input className="form-control" name="phone" value={businessData?.phone} placeholder="Enter Location Name"   onChange={handleChange}/>
                        {error && <span className="errormsg" style={{
                                        fontWeight: 'bold',
                                        color: 'red',
                                    }}>{error?.phone}</span>}
                        </div>
<label className="form_label mt-3" for="location-name">BUSINESS ADDRESS <span className="required">*</span></label>
<div className="input-group mb-2 mr-sm-2">
                        <div className="input-group-prepend">
                        <div className="input-group-text">
                        <span className="material-symbols-outlined">location_on</span>
                        </div>
                        </div>
                        {mapsAPIkey != false && <LocationSearch
                                                                        setSelectedPlace={(place) => {
                                                                            setSelectedPlace(place);
                                                                            handleAddressChange(addressData);
                                                                        }}
                                                                        setAddressData={(data) => {
                                                                            setAddressData(data);
                                                                            handleAddressChange(data);
                                                                        }}
                                                                        //  setEditUser={(data) => {
                                                                        //     setEditUser(data);
                                                                        //     handleChange(data);
                                                                        // }}
                                                                        onChange={(e) => {
                                                                            setBusinessData((prev) => ({ ...prev, businessaddress: e.target.value }));
                                                                            setAddressData({ fullAddress: e.target.value });  // Ensure addressData is also updated
                                                                        }}
                                                                        onBlur={() => handleAddressChange({ fullAddress: businessData?.businessaddress })}
                                                                        mapVisible={false}
                                                                        formData={businessData}
                                                                        mapsAPIkey={mapsAPIkey}
                                                                        id="business-address-input"
                                                                    />}
                                                                       {error && <span className="errormsg" style={{
                                        fontWeight: 'bold',
                                        color: 'red',
                                    }}>{error?.businessaddress}</span>}
                        </div>
                        <label className="form_label mt-3" htmlFor="html">Upload Logo</label>

<div className="upload-zone input-group mb-2 mr-sm-2">
{businessData?.logo?.length > 0 ?
    <div className="upload-icon mt-1">
        <div className="img_block add_img_block">
            <span className="material-icons-outlined thumbnail-cls-icon" onClick={handleRemove}>close</span>

            <img
  src={
    Array.isArray(businessData?.logo) && businessData?.logo.length > 0
      ? businessData?.logo[0]?.filepath
      : image + businessData?.logo || "" // Fallback to an empty string if no valid image is found
  }
  id="activimg"z
/>
            {/* <img id="activimg" src={uploadImg ? uploadImg : "assets/img/store-thumb-img.jpg"} width={150} /> */}
        </div>
    </div> :
    <>

        <div>

            <input
                type="file"
                id="file-upload"
                accept="image/jpeg, image/png,image/heic,image/jpg"
                className="d-none"
                multiple={false}
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />

            <label
                htmlFor="file-upload" className="stroke-button"
            >
                <span className="material-icons">file_upload</span>
            </label>
        </div>
        <div className="file_requirements ">
            <p>Maximum file size: 5MB</p>
            <p>Supported formats: JPG, PNG, HEIC</p>
        </div></>

}
</div>
                        <button className="fill-btn save_continue" onClick={handleSave}>{btnLoader ? (
                    <img 
                       src={`${image}${appname}/images/web/rotate_right.svg`} 
                       className="loading-icon" 
                    />
                 ) : null}Save</button>
</div>
<div className="col-md-6"></div>
</div>
{/* Business Profile End here */}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <SweetAlert show={tableErrMsg}
                         custom
                         confirmBtnText="ok"
                         confirmBtnBsStyle="primary"
                         title={"Something went wrong. Please reload again."}
                         onConfirm={e => setTableErrMsg(false)}
                     >
                     </SweetAlert>
                        <Footer />
                        <ToastContainer
      position="bottom-center"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover={false}
      theme="light"
      id="toastContainer"
    />
                    </div>
             


            </div>
        </>
    );
};

export default BusinessProfile;
